<!-- 绑定邮箱 -->
<template>
  <div class="container containerBox">
	<div>项目名称:<span>{{form.project_name}}</span></div>
	<div>项目负责人:<span>{{form.project_principal_name}}</span></div>
	<div>项目负责人电话:<span>{{form.project_principal_tel}}</span></div>
<!-- 	<div>物业:<span>{{form.property}}</span></div>
	<div>物业负责人:<span>{{form.property_principal_name}}</span></div>
	<div>物业负责人电话:<span>{{form.property_tel}}</span></div> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Service from '@/api/Service'

export default {
    name: "changepassword",
    inject: ["reload"],
    data() {
        return {
            form: {
				project_name:'',
				project_principal_name:'',
				project_principal_tel:'',
				property:'',
				property_principal_name:'',
				property_tel:'',
			},
        };
    },
    computed: {
        // 项目列表
        ...mapGetters(["user"])
    },
	created() {
		this.getuserinfo()
	},
    methods: {
		async getuserinfo(){
			let res = await Service.getAftersales();
			this.form=res
		},
		async onSubmitCode(){
		},
    }
};
</script>
<style lang='css' scoped>
.container div{
    width: 100%;
	height: 30px;
	font-size: 20px;
	line-height: 30px;
	font-weight: bold;
	text-align: center;
    margin-bottom: 20px;
}
</style>